import { KeyboardEvent, useState } from 'react';
import { Text } from '../../Atoms/Text';
import { CustomFieldDatePicker } from '../CustomFieldDatePicker/CustomFieldDatePicker';
import { parseCustomFieldDate, serializeCustomFieldDate } from '../../../utils/customFieldTypes';

export interface DateValueEditorProps {
  value: string;
  disabled: boolean;
  onChange: (value: string) => void;
  onKeyDown: (event: KeyboardEvent) => void;
  onValidityChange: (valid: boolean) => void;
  // What the empty picker stands in for, so a value it cannot hold is not deleted out of sight.
  replacing: string;
}

// Holds the day being typed: a half-written one has no stored string to be controlled by.
export const DateValueEditor = ({
  value,
  disabled,
  onChange,
  onKeyDown,
  onValidityChange,
  replacing
}: DateValueEditorProps) => {
  const [picked, setPicked] = useState<Date | null>(() => parseCustomFieldDate(value));

  return (
    <div className="w-full">
      <CustomFieldDatePicker
        value={picked}
        disabled={disabled}
        takeFocus
        onKeyDown={onKeyDown}
        onChange={(next, acceptable) => {
          setPicked(next);
          onValidityChange(acceptable);
          if (acceptable) onChange(serializeCustomFieldDate(next));
        }}
      />
      {replacing && (
        <Text
          color="grey6"
          size="xs"
          className="block mt-1">
          {`Replacing ${replacing}`}
        </Text>
      )}
    </div>
  );
};
